import ApplicationController from "../application_component_controller";

import { useOutlets } from "hb/insights/use_outlets";

export default class extends ApplicationController {
  connect() {
    useOutlets(this, { components: ["handsfree"] });
  }

  valSel(evt) {
    if (!window.getSelection().isCollapsed) {
      return;
    }

    const { type, value, path } = evt.target.dataset;
    this.outletComponent("handsfree").show(type, path, value, {
      element: this.element,
      context: "error",
      addToField: false,
    });
  }
}
